let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("fMrUo"), load("bJykp"), load("4Wdqb"), load("fjbzp"), load("9v6ER"), load("aEAsN")]).then(() => parcelRequire('dUARU'));